module.exports = __webpack_public_path__ + "static/media/5.3d2083ba.jpg";